(function(){

function getVariantData(root){
  const script=root.querySelector('script[type="application/json"]');
  if(!script) return null;
  return JSON.parse(script.textContent);
}

function getSelectedOptions(root){
  return [...root.querySelectorAll("fieldset")].map(fs=>{
    const sel=fs.querySelector("select");
    if(sel) return sel.value;
    const checked=fs.querySelector("input:checked");
    return checked?checked.value:null;
  });
}

function findVariant(variants, selected){
  const sel = selected.map(norm);
  return variants.find(v => {
    if (!v.options || v.options.length !== sel.length) return false;
    return v.options.every((o,i) => norm(o) === sel[i]);
  }) || null;
}


function money(cents){
  return new Intl.NumberFormat("tr-TR",{style:"currency",currency:"TRY"}).format(cents/100);
}
function norm(s){
  return (s ?? "")
    .toString()
    .normalize("NFD")                 // ş/ğ/ö gibi harfleri ayır
    .replace(/[\u0300-\u036f]/g,"")   // aksanları temizle
    .replace(/[İI]/g,"i")             // İ/I -> i
    .replace(/ı/g,"i")                // ı -> i
    .replace(/\u00A0/g," ")           // NBSP -> normal boşluk
    .replace(/\s+/g," ")              // çoklu boşluk -> tek boşluk
    .trim()
    .toLowerCase();
}

function instantUI(variant){

  /* fiyat */
  const p=document.querySelector("[data-price-current]");
  if(p) p.textContent=money(variant.price);

  const c=document.querySelector("[data-price-compare]");
  if(c){
    if(variant.compare_at_price && variant.compare_at_price>variant.price){
      c.textContent=money(variant.compare_at_price);
      c.closest("del")?.classList.remove("hidden");
    }else{
      c.closest("del")?.classList.add("hidden");
    }
  }

  /* resim */
  if(variant.featured_image?.src){
    const img=document.querySelector(".product__media img, .product-gallery img");
    if(img) img.src=variant.featured_image.src;
  }

  /* buton */
  document.querySelectorAll(".single-add-to-cart-button").forEach(btn=>{
    btn.disabled=!variant.available;
  });

}

async function syncServer(root,variantId){
  const url=new URL(root.dataset.url,location.origin);
  url.searchParams.set("variant",variantId);
  url.searchParams.set("section_id",root.dataset.section);

  const html=await fetch(url).then(r=>r.text());
  const doc=new DOMParser().parseFromString(html,"text/html");

  [
    "price",
    "sku",
    "inventory"
  ].forEach(type=>{
    const fresh=doc.querySelector(`[id^=${type}-]`);
    const cur=document.querySelector(`[id^=${type}-]`);
    if(fresh && cur) cur.innerHTML=fresh.innerHTML;
  });
}

document.addEventListener("change",async e=>{

  const root=e.target.closest("variant-selects");
  if(!root) return;

  const variants=getVariantData(root);
  if(!variants) return;

  const selected=getSelectedOptions(root);
  const variant=findVariant(variants,selected);
  if(!variant) return;

  /* instant */
  instantUI(variant);

  /* form id update */
  document.querySelectorAll('form[id^="product-form-"]').forEach(f=>{
    const input=f.querySelector('[name="id"]');
    if(input) input.value=variant.id;
  });

  /* async sync */
  syncServer(root,variant.id);

});

})();




